import React from "react";
import {PreviewContainer, FileMetaData} from "../../CandidatForm/Controls/InputFile/InputFile.styles";
import {FaRegTrashAlt} from "react-icons/fa";

export default function FilePreviewOld({oldFiles, updateOldFilesCb}) {
  return (
    <>
      {oldFiles.map((oldFile) => {
        let fileName = oldFile.imageName;
        let key = oldFile.id;

        return (
          <PreviewContainer key={key}>
            <FileMetaData style={{ cursor: "default", justifyContent: "space-between" }}>
              <span style={{ overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>{fileName}</span>
              <span>
                <FaRegTrashAlt onClick={() => updateOldFilesCb(key)} style={{ cursor: "pointer" }} />
              </span>
            </FileMetaData>
          </PreviewContainer>
        );
      })}
    </>
  );
}
